<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <!-- <router-link :to="'/seeLicenseapplyszbjx/'+licenseApplyId">
                        <i class="el-icon-arrow-left" style="cursor: pointer;"></i>
                        牌照查看
                    </router-link>/总部添加牌照 -->
					<i class="el-icon-arrow-left" style="cursor: pointer;" @click="$router.go(-1)"></i>
					牌照查看 / 总部添加牌照
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-form
                class="addlicense-box"
                ref="addlicenseform"
                :model="addlicenseform"
                :rules="addlicenserules"
            >
                <div class="addlicense-item">
                    <el-form-item label="设备编码" prop="equipmentCode">
                        <el-input v-model="addlicenseform.equipmentCode"></el-input>
                    </el-form-item>
                    <el-form-item label="整机架号" prop="frameNo">
                        <el-input v-model="addlicenseform.frameNo"></el-input>
                    </el-form-item>
                </div>
                <div class="addlicense-item">
                    <el-form-item label="环保编号" prop="environmentalProtectionNumber">
                        <el-input v-model="addlicenseform.environmentalProtectionNumber"></el-input>
                    </el-form-item>
                    <el-form-item label="燃油类型" prop="fuelType">
                        <el-input v-model="addlicenseform.fuelType"></el-input>
                    </el-form-item>
                </div>
                <div class="addlicense-item">
                    <el-form-item label="排放登记" prop="emissionRegistration">
                        <el-input v-model="addlicenseform.emissionRegistration"></el-input>
                    </el-form-item>
                    <el-form-item label="发动机号" prop="engineNumber">
                        <el-input v-model="addlicenseform.engineNumber"></el-input>
                    </el-form-item>
                </div>
                <div class="addlicense-item">
                    <el-form-item label="发动机功率" prop="enginePower">
                        <el-input v-model="addlicenseform.enginePower"></el-input>
                    </el-form-item>
                    <el-form-item label="整机质量" prop="overallQuality">
                        <el-input v-model="addlicenseform.overallQuality"></el-input>
                    </el-form-item>
                </div>
                <div class="addlicense-item">
                    <el-form-item label="机械品牌" prop="machineryBrand">
                        <el-input v-model="addlicenseform.machineryBrand"></el-input>
                    </el-form-item>
                    <el-form-item label="出厂日期" prop="productionDateStr">
                        <el-date-picker
                            v-model="addlicenseform.productionDateStr"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="出厂日期"
                        ></el-date-picker>
                    </el-form-item>
                </div>
                <div class="addlicense-item">
                    <el-form-item label="机械颜色" prop="machineryColor">
                        <el-input v-model="addlicenseform.machineryColor"></el-input>
                    </el-form-item>
                    <el-form-item label="核载信息" prop="nuclearInformation">
                        <el-input v-model="addlicenseform.nuclearInformation"></el-input>
                    </el-form-item>
                </div>
                <div class="addlicense-item">
                    <el-form-item label="机械类型" prop="machineryType">
                        <el-input v-model="addlicenseform.machineryType"></el-input>
                    </el-form-item>
                    <el-form-item label="生产国" prop="productionCountry">
                        <el-input v-model="addlicenseform.productionCountry"></el-input>
                    </el-form-item>
                </div>
                <div class="addlicense-item">
                    <el-form-item label="生产厂家" prop="factory">
                        <el-input v-model="addlicenseform.factory"></el-input>
                    </el-form-item>
                </div>

                <!-- <el-form-item label="添加照片" prop="mechanicalPictures" style="width: 800px;">
					   <el-upload
						 action="#"
						 list-type="picture-card"
						 :on-preview="handlePictureCardPreview"
						 :on-remove="handleRemove"
						 :http-request="uploadAvatar"
						 :before-upload="beforeAvatarUpload"
						 :file-list="fileList"
					   >
						 <i class="el-icon-plus"></i>
					   </el-upload>
					   <el-dialog :visible.sync="dialogVisible">
						 <img width="100%" :src="dialogImageUrl" alt="">
					   </el-dialog>
                </el-form-item>-->

                <!-- <el-button
						type="primary"
						class="handle-del mr10"
						@click = 'uploadbtn()'
                >提交</el-button>-->
                <span>
                    <el-button type="primary" @click="saveAddlicense('addlicenseform')">确 定</el-button>
                    <el-button @click="cancelAddlicense('addlicenseform')">取 消</el-button>
                </span>
            </el-form>
        </div>
    </div>
</template>

<script>
	import {updatePcLicenseApply,getLicenseApply} from '@/api/index';
    export default {
        name: 'addlicense',
        data() {
            return {
			addlicenseform:{
			 	equipmentCode:'',
				frameNo:'',
				environmentalProtectionNumber:'',
				fuelType:'',
				emissionRegistration:'',
				engineNumber:'',
				enginePower:'',
				overallQuality:'',
				machineryBrand:'',
				productionDateStr:'',
				machineryColor:'',
				nuclearInformation:'',
				machineryType:'',
				productionCountry:'',
				factory:'',
				// mechanicalPictures:''
			 },    //添加机构分支表单
			 addlicenserules: {
			 	  equipmentCode: [
			 		{ required: true, message: '请输入设备编号', trigger: 'blur' }
			 	  ],
			 },  //添加表单验证
				
				
             dialogImageUrl: '',
			 dialogVisible: false,
			 picList: [],
			 fileList: [],
			 imgArr:[]
				
               
            }
        },
		created() {
			this.licenseApplyId = this.$route.params.licenseApplyId;
			// 查看
			this.getLicenseApplylist();
		},
        methods: {
			getLicenseApplylist(){
				getLicenseApply({
					"licenseApplyId": this.licenseApplyId
				}).then(res => {
					this.addlicenseform = res.data;
					// this.mechanicsId = res.data.mechanicsId;
					// console.log(this.mechanicsId)
				});
			},
			uploadAvatar(item) {
				var picobj = {};
				const _file = item.file;
				console.log(_file)
				picobj.uid = item.file.uid;
				var formData = new FormData();
				formData.append("file", _file);
				this.$http({
					method:'post',
					headers: { 'Content-Type': 'multipart/form-data' },
					url:"/api/homepage/uploadImages",
					data:formData,
					crossDomain:true,
					cache:false
				}).then(res => {
					picobj.url = res.data.data[0];
					this.picList.push(picobj);
					console.log(2,this.picList)
				  // this.emptyUpload()
				}).catch(() => {
				  this.$message.error('上传失败，请重新上传')
				  // this.emptyUpload()
				})
				
			},
			beforeAvatarUpload(file) {
			  const isJPG = file.type === 'image/jpeg'
			  const isPng = file.type === 'image/png'
			  const isLt2M = file.size / 1024 / 1024 < 2
	 
			  if (!isJPG && !isPng) {
				this.$message.error('上传图片只能是 JPG或png 格式!')
			  }
			  if (!isLt2M) {
				this.$message.error('上传图片大小不能超过 2MB!')
			  }
			  return (isJPG || isPng) && isLt2M
			},
			handleRemove(file, fileList) {
			  for (const i in this.picList) {
				if (this.picList[i].uid === file.uid) {
				  this.picList.splice(i, 1)
				}
			  }
			},
			uploadbtn(){
				console.log(this.picList)
			},
			cancelAddlicense(formName){
				//重置表单数据
				this.$nextTick(()=>{
				  this.$refs.[formName].resetFields();
				});
				// this.$router.push('/licenseapplys');
				// this.$router.push({name: 'seeLicenseapplyszbjx', params: {licenseApplyId: this.licenseApplyId}})
				this.$router.back()
			},
			saveAddlicense(formName) {
				this.$refs[formName].validate((valid) => {
				  if (valid) {
					  // var mechanicalPicStr = '';
					  // if(this.picList.length>0){
						 //  for(var i in this.picList){
							//   if(i == 0){
							// 	  mechanicalPicStr += this.picList[i].url;
							//   }else {
							// 	  mechanicalPicStr += ',' + this.picList[i].url;
							//   }
							
						 //  }
					  // }
					  // this.addlicenseform.mechanicalPictures = mechanicalPicStr;
					  console.log('表单数据',this.addlicenseform);
					  updatePcLicenseApply(this.addlicenseform).then(res => {
						  if(res.code == 0){
							  // 获取数据成功后的其他操作
								this.$message({
								  message: res.message,
								  type: 'success'
								});
								this.$router.push({name: 'seeLicenseapplyszbjx', params: {licenseApplyId: this.licenseApplyId}})
						  }else if(res.code == 1){
							  this.$message({
							    message: res.message,
							    type: 'warning'
							  });
						  }else{
							  this.$message({
							    message: '报错啦!',
							    type: 'warning'
							  });
						  }
						   
					  });
				  } else {
					return false;
				  }
				});
			  },
			handlePictureCardPreview(file) {
			  this.dialogImageUrl = file.url
			  this.dialogVisible = true
			},
			/**
			 * 清空上传组件
			 */
			// emptyUpload() {
			//   const mainImg = this.$refs.upload
			//   if (mainImg) {
			//     if (mainImg.length) {
			//       mainImg.forEach(item => {
			//         item.clearFiles()
			//       })
			//     } else {
			//       this.$refs.upload.clearFiles()
			//     }
			//   }
			// }
        },
        computed: {
            
        }
    }

</script>

<style>
.addlicense-item {
    display: flex;
    display: -webkit-flex;
}
.addlicense-item .el-form-item {
    width: 300px;
    margin-right: 50px;
}
.addlicense-item .el-date-editor.el-input,
.addlicense-item .el-date-editor.el-input__inner {
    width: 100%;
}
</style>
